/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import moment from "../../../utils/customMoment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "moment/locale/ja";
import { getBookingPriceBreakdown } from "../../../utils/discount";

const NewItemCardPaymentSuccess = ({ cart }) => {
  const { t, i18n } = useTranslation();
  const [meetAssist, setMeetAssist] = useState("");
  const [allChildSeatSize, setAllChildSeatSize] = useState(0);
  const [allInfantSeatSize, setAllInfantSeatSize] = useState(0);
  const [allToddlerSeatSize, setAllToddlerSeatSize] = useState(0);
  const [keyBook, setKeyBook] = useState(null);

  if (i18n.language === "en") {
    moment.locale("en");
  } else {
    moment.locale("ja");
  }

  const formatDate = {
    "en": "MMM. Do, YYYY (ddd) HH:mm",
    "EN": "MMM. Do, YYYY (ddd) HH:mm",
    "jp": "YYYY年M月D日(dd) HH:mm",
    "JP": "YYYY年M月D日(dd) HH:mm"
  }

  useEffect(() => {
    if (
      cart.meetAssist[0].meetAssistName === "none" &&
      cart.meetAssist[1].meetAssistName !== "none"
    ) {
      setMeetAssist("departure");
    } else if (
      cart.meetAssist[0].meetAssistName !== "none" &&
      cart.meetAssist[1].meetAssistName === "none"
    ) {
      setMeetAssist("arrival");
    } else if (
      cart.meetAssist[0].meetAssistName !== "none" &&
      cart.meetAssist[1].meetAssistName !== "none"
    ) {
      setMeetAssist("both");
    } else if (
      cart.meetAssist[0].meetAssistName === "none" &&
      cart.meetAssist[1].meetAssistName === "none"
    ) {
      setMeetAssist("");
    }

    cart.bookingInfo.map((i) => {
      setAllInfantSeatSize(allInfantSeatSize + i.childSeat[0].childSeatCount);
      setAllToddlerSeatSize(allToddlerSeatSize + i.childSeat[1].childSeatCount);
      setAllChildSeatSize(allChildSeatSize + i.childSeat[2].childSeatCount);
    });
  }, []);

  const getCountChildSeat = () => {
    const totalCount = cart.bookingInfo.reduce((acc, booking) => {
      return booking.childSeat.reduce((acc, seat) => {
        return acc + seat.childSeatCount;
      }, acc);
    }, 0);

    return totalCount;
  };

  const getChildSeatView = () => {
    var count = 0;
    var infant = 0;
    var toddler = 0;
    var child = 0;
    cart?.bookingInfo.forEach((booking) => {
      // Iterate over childSeat array within each booking
      infant += booking.childSeat[0].childSeatCount;
      toddler += booking.childSeat[1].childSeatCount;
      child += booking.childSeat[2].childSeatCount;
    });

    return `Child Seats (${infant > 0
      ? `${t("NewCart.AddOnServices.ChildSeat.Infant")} x${infant}`
      : ""
      } ${toddler > 0
        ? `${t("NewCart.AddOnServices.ChildSeat.Toddler")} x${toddler}`
        : ""
      } ${child > 0 ? `${t("NewCart.AddOnServices.ChildSeat.Child")} x${child}` : ""
      })`;
  };

  // Amount actually charged, and the price it was discounted from — derived from the
  // booking's unified `discount` object so quotation, campaign and IATA bookings all
  // report the same way (a populated `quotation` is no longer needed).
  const priceBreakdown = getBookingPriceBreakdown(cart);

  const getTransferTypeLabel = () => {
    if (cart?.bookingType === "byTheHour") {
      return t("myPage.booking.bookingItem.bookingType.byTheHour");
    } else {
      if (cart?.isAirportTransfer) {
        return t("myPage.booking.bookingItem.bookingType.airportTransfer");
      } else {
        return t("myPage.booking.bookingItem.bookingType.specifiedDestination");
      }
    }
  }

  const getLocationDetail = (loc) => {
    const formattedAddressArr = loc?.formatted_address?.split(",");
    const name = formattedAddressArr?.[0];
    const address = formattedAddressArr?.slice(1).join(",");

    return {
      name,
      address
    }
  }

  const getAddOnServices = () => {
    let addOnServices = "";

    if (cart?.meetAssist[0].meetAssistName !== "none" || cart?.meetAssist[1].meetAssistName !== "none") {
      if (cart?.meetAssist[0].meetAssistName !== "none") {
        const text = t(`myPage.booking.bookingItem.addOnService.${cart?.meetAssist[0].meetAssistName}.${cart?.isFromAirport ? "airport" : "station"}.arrival`);
        addOnServices += text;

        if (cart?.meetAssist[1].meetAssistName !== "none") addOnServices += `\n`
      }

      if (cart?.meetAssist[1].meetAssistName !== "none") {
        const text = t(`myPage.booking.bookingItem.addOnService.${cart?.meetAssist[1].meetAssistName}.${cart?.isFromAirport ? "airport" : "station"}.departure`);
        addOnServices += text;
      }

      if (cart.totalChildSeatPrice > 0) addOnServices += `\n`
    }

    if (cart.totalChildSeatPrice > 0) {
      const countInfant = cart.bookingInfo.reduce((sum, booking) => sum + booking?.childSeat[0]?.childSeatCount, 0)
      const countToddler = cart.bookingInfo.reduce((sum, booking) => sum + booking?.childSeat[1]?.childSeatCount, 0)
      const countChild = cart.bookingInfo.reduce((sum, booking) => sum + booking?.childSeat[2]?.childSeatCount, 0)

      const text = `${t(`myPage.booking.bookingItem.addOnService.childSeat`)} (${countInfant > 0 ? `${t(`myPage.booking.bookingItem.addOnService.childSeatType.infant`, { count: countInfant })}` : ""}${(countInfant > 0 && (countToddler > 0 || countChild > 0)) ? ", " : ""}${countToddler > 0 ? `${t(`myPage.booking.bookingItem.addOnService.childSeatType.toddler`, { count: countToddler })}` : ""}${(countToddler > 0 && countChild > 0) ? ", " : ""}${countChild > 0 ? `${t(`myPage.booking.bookingItem.addOnService.childSeatType.child`, { count: countChild })}` : ""})`;
      addOnServices += text;
    }

    return addOnServices;
  }

  function minutesToHoursCeil(minutes) {
    return Math.ceil(minutes / 30) * 0.5;
  }

  const getAdditionalInformation = () => {
    if (!cart?.pickupFlightNo && !cart?.dropoffFlightNo) {
      return <span className="tw:!text-[#8d8d8d] tw:!italic">{t("myPage.booking.bookingItem.additionalInformation.none")}</span>;
    }

    let additionalInformation = "";

    if (cart?.pickupFlightNo) {
      additionalInformation += t(`myPage.booking.bookingItem.additionalInformation.flightNumber.${cart?.isFromAirport ? "airport" : "station"}.arrival`, {
        pickupFlightNo: cart?.pickupFlightNo,
        pickupSign: `${cart?.pickupSignHonorific || "-"} ${cart?.pickupSign}`
      })

      if (cart?.dropoffFlightNo) additionalInformation += `\n`;
    }

    if (cart?.dropoffFlightNo) {
      additionalInformation += t(`myPage.booking.bookingItem.additionalInformation.flightNumber.${cart?.isToAirport ? "airport" : "station"}.departure`, {
        dropoffFlightNo: cart?.dropoffFlightNo,
      })
    }

    return additionalInformation;
  }

  return (
    <>
      <div className="tw:!mb-5">
        <div
          className="tw:!mx-auto tw:!bg-white tw:!border tw:!border-[#E8E8E8] tw:!border-t-0 tw:md:!border-t tw:md:!rounded-lg tw:!rounded-b-lg tw:!shadow-sm tw:!font-sans tw:!transition-shadow tw:!duration-200 tw:hover:!shadow-md"
        >
          <div className="tw:!p-4 tw:md:!p-6">
            <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />

            {/* Row 2: Passenger Name - Type of Transfer (Mobile) */}
            <div className="tw:!flex tw:!justify-between tw:!items-start tw:!gap-2 tw:md:hidden!">
              <div className="tw:!flex-1">
                <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.passengerName')}</p>
                <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{cart?.passengerName}</p>
              </div>
              <div className="tw:!flex-1">
                <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.transferType')}</p>
                <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{getTransferTypeLabel()}</p>
              </div>
            </div>

            <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />

            {/* Row 2A: Pick-up Time - Estimated Drop-off Time (Mobile) */}
            <div className="tw:!flex tw:!justify-between tw:!items-start tw:!gap-2 tw:md:hidden!">
              <div className="tw:!flex-1">
                <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.pickupTime')}</p>
                <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!m-0">{moment(cart?.pickupDateTime).format(formatDate[i18n.language])}</p>
              </div>
              <div className="tw:!flex-1">
                <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.dropoffTime')}</p>
                <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!m-0">{moment(cart?.customerDropoffDateTime).format(formatDate[i18n.language])}</p>
              </div>
            </div>

            <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />

            {/* Row 3: Pickup Location (Mobile) */}
            <div className="tw:md:hidden! tw:!mb-6">
              <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.pickupLocation')}</p>
              <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{getLocationDetail(cart?.pickupLocation).name}</p>
              <p className="tw:!text-[13px] tw:!font-[400] tw:!text-[#7C7B7B] tw:!m-0">{getLocationDetail(cart?.pickupLocation).address}</p>
            </div>

            {/* Row 4: Dropoff Location (Mobile) */}
            {cart?.destinations.map((item, index) => {
              const isSingle = cart.destinations.length === 1;
              const isLast = index === cart.destinations.length - 1;

              return (
                <div
                  key={index}
                  className={`tw:md:hidden! ${!isLast ? 'tw:!mb-6' : ''}`}
                >
                  <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">
                    {`${!isSingle ? `${index + 1}.` : ''} ${t('myPage.booking.bookingItem.title.dropoffLocation')}`}
                  </p>

                  <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">
                    {getLocationDetail(item).name}
                  </p>

                  <p className="tw:!text-[13px] tw:!font-[400] tw:!text-[#7C7B7B] tw:!m-0">
                    {getLocationDetail(item).address}
                  </p>
                </div>
              );
            })}

            {
              cart.bookingType === "byTheHour" && (
                <>
                  <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />

                  {/* Row 5: Travel Area (Mobile) */}
                  <div className="tw:md:hidden! tw:!mb-6">
                    <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.travelArea")}</p>
                    <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{`${t("myPage.booking.bookingItem.travelArea." + cart.travelArea)}`}</p>
                  </div>

                  {/* Row 6: Billed & Usage Duration (Mobile) */}
                  <div className="tw:!flex tw:!justify-between tw:!items-start tw:!gap-4 tw:md:hidden!">
                    <div className="tw:!flex-1">
                      <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.usageDuration")}</p>
                      <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{`${minutesToHoursCeil(cart?.usageDuration)}${t("myPage.booking.bookingItem.title.hours")}`}</p>
                    </div>
                    <div className="tw:!flex-1">
                      <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.billedDuration")}</p>
                      <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{`${minutesToHoursCeil(cart?.billedDuration)}${t("myPage.booking.bookingItem.title.hours")}`}</p>
                    </div>
                  </div>
                </>
              )
            }

            {/* Desktop Layout - First Row */}
            <div className="tw:hidden! tw:md:!flex tw:!justify-between tw:!items-start">
              <div className="tw:!flex tw:!gap-2 tw:!flex-1">
                <div className="tw:!min-w-1/4">
                  <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.bookingId")}</p>
                  <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{`#${cart?.key}`}</p>
                </div>
                <div className="tw:!flex-1 tw:!min-w-1/8">
                  <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.passengerName')}</p>
                  <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{cart?.passengerName}</p>
                </div>
                <div className="tw:!flex-1 tw:!min-w-0">
                  <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.transferType')}</p>
                  <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0 tw:!truncate">{getTransferTypeLabel()}</p>
                </div>
              </div>


            </div>

            <hr className="tw:!my-4 tw:!border-gray-100 tw:hidden! tw:md:block!" />

            {/* Desktop - Pick-up Section (Hidden on Mobile) */}
            <div className="tw:hidden! tw:md:!flex tw:!justify-between tw:!items-start">
              <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
                <div className="tw:!w-1/3">
                  <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.pickupTime')}</p>
                  <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{moment(cart?.pickupDateTime).format(formatDate[i18n.language])}</p>
                </div>
                <div className="tw:!w-2/3">
                  <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.pickupLocation')}</p>
                  <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{getLocationDetail(cart?.pickupLocation).name}</p>
                  <p className="tw:!text-[13px] tw:!font-[400] tw:!text-[#7C7B7B] tw:!m-0">{getLocationDetail(cart?.pickupLocation).address}</p>
                </div>
              </div>
            </div>

            <hr className="tw:!my-4 tw:!border-gray-100 tw:hidden! tw:md:block!" />

            {/* Desktop - Drop-off Section (Hidden on Mobile) */}
            <div className="tw:hidden! tw:md:!flex tw:!justify-between tw:!items-start">
              <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
                <div className="tw:!w-1/3">
                  <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t('myPage.booking.bookingItem.title.dropoffTime')}</p>
                  <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{moment(cart?.customerDropoffDateTime).format(formatDate[i18n.language])}</p>
                </div>
                <div className="tw:!w-2/3">
                  {cart?.destinations.map((item, index) => {
                    const isSingle = cart.destinations.length === 1;
                    const isLast = index === cart.destinations.length - 1;

                    return (
                      <div
                        key={index}
                        className={`tw:!w-full ${!isLast ? 'tw:!mb-6' : ''}`}
                      >
                        <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">
                          {`${!isSingle ? `${index + 1}.` : ''} ${t('myPage.booking.bookingItem.title.dropoffLocation')}`}
                        </p>

                        <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">
                          {getLocationDetail(item).name}
                        </p>

                        <p className="tw:!text-[13px] tw:!font-[400] tw:!text-[#7C7B7B] tw:!m-0">
                          {getLocationDetail(item).address}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {
              cart.bookingType === "byTheHour" && (
                <>
                  <hr className="tw:!my-4 tw:!border-gray-100 tw:hidden! tw:md:block!" />

                  {/* Desktop - Travel Area Section (Hidden on Mobile) */}
                  <div className="tw:hidden! tw:md:!flex tw:!justify-between tw:!items-start">
                    <div className="tw:!w-3/4 tw:!flex tw:!gap-3">
                      <div className="tw:!w-1/3">
                        <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.travelArea")}</p>
                        <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{`${t("NewCart.AddOnServices.TravelArea." + cart.travelArea)}`}</p>
                      </div>
                      <div className="tw:!w-1/3 tw:!flex tw:!gap-2">
                        <div className="tw:!w-1/2">
                          <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.usageDuration")}</p>
                          <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{`${minutesToHoursCeil(cart?.usageDuration)}${t("myPage.booking.bookingItem.title.hours")}`}</p>
                        </div>
                        <div className="tw:!w-1/2">
                          <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.billedDuration")}</p>
                          <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{`${minutesToHoursCeil(cart?.billedDuration)}${t("myPage.booking.bookingItem.title.hours")}`}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )
            }

            {/* Show More Section - Collapsible */}
            <div
              className={`tw:!overflow-hidden tw:!transition-all tw:!duration-500 tw:!ease-in-out tw:!max-h-[500px] tw:!opacity-100`}
            >
              <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />

              {/* Row 5: Vehicle (Mobile) */}
              {cart?.bookingInfo.map((item, index) => {
                const isSingle = cart.bookingInfo.length === 1;
                const isLast = index === cart.bookingInfo.length - 1;
                return (
                  <div>
                    <div
                      key={index}
                      className={`tw:md:hidden! ${!isLast ? 'tw:!mb-6' : ''}`}
                    >
                      <div className="tw:md:hidden! tw:!mb-2">
                        <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{`${t("myPage.booking.bookingItem.title.vehicle")}${!isSingle ? ` ${index + 1}` : ''}`}</p>
                        <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{t(item.vehicleTypeName.replace(/ /g, "."))}</p>
                      </div>


                      {/* Row 6: Passenger - Luggage (Mobile) */}
                      <div className="tw:!flex tw:!justify-between tw:!items-start tw:!gap-4 tw:md:hidden!">
                        <div className="tw:!flex-1">
                          <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.passenger")}</p>
                          <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">
                            {item.pax
                              .filter((passenger) => passenger.paxcount > 0)
                              .map((passenger, index, array) => (
                                <span key={passenger.paxtype}>
                                  {t(`my_page.bookings_page.booking_item.${passenger.paxtype}`)}: {passenger.paxcount}
                                  {index !== array.length - 1 ? ", " : ""}
                                </span>
                              ))}
                          </p>
                        </div>
                        <div className="tw:!flex-1">
                          <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.luggage")}</p>
                          <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">
                            {item.luggage.filter((luggage) => luggage.luggagecount > 0).length > 0
                              ? item.luggage
                                .filter((luggage) => luggage.luggagecount > 0)
                                .map((luggage, index, array) => (
                                  <span key={luggage.luggagetype}>
                                    {luggage.luggagetype === "CHECK-IN SIZE"
                                      ? t("my_page.bookings_page.booking_item.check_in")
                                      : t("my_page.bookings_page.booking_item.cabin")}
                                    : {luggage.luggagecount}
                                    {index !== array.length - 1 ? ", " : ""}
                                  </span>
                                ))
                              : i18n.language === "en" ? <span className="tw:!text-[#8d8d8d] tw:!italic">None</span> : <span className="tw:!text-[#8d8d8d] tw:!italic">なし</span>}
                          </p>
                        </div>
                      </div>
                      {(index + 1) < cart.bookingInfo.length &&
                        <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />
                      }
                    </div>
                  </div>
                )
              })}

              <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />

              {/* Row 7: Add on services (Mobile) */}
              <div className="tw:md:hidden!">
                <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.addOnService")}</p>
                <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{getAddOnServices()}</p>
              </div>

              <hr className="tw:!my-4 tw:!border-gray-100 tw:md:hidden!" />

              {/* Row 8: Additional Information (Mobile) */}
              <div className="tw:md:hidden!">
                <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.additionalInformation")}</p>
                <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{getAdditionalInformation()}</p>
              </div>

              {/* Desktop - Show More Section */}
              <hr className="tw:!my-4 tw:!border-gray-100 tw:hidden! tw:md:block!" />

              {[...cart?.bookingInfo].map((item, index) => {
                // const isSingle = cart.destinations.length === 1;
                const isSingle = cart.bookingInfo.length === 1;
                const isLast = index === cart.destinations.length - 1;
                return (
                  <div>
                    <div className={`tw:hidden! tw:md:!flex tw:!justify-between tw:!items-start ${!isLast ? 'tw:!mb-6' : ''}`}>
                      <div className="tw:!w-3/4 tw:!flex tw:!gap-3">
                        <div className="tw:!w-1/3">
                          <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{`${t("myPage.booking.bookingItem.title.vehicle")}${!isSingle ? ` ${index + 1}` : ''}`}</p>
                          <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{t(item.vehicleTypeName.replace(/ /g, "."))}</p>
                        </div>
                        <div className="tw:!w-1/2">
                          <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.luggage")}</p>
                          <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">
                            {item.luggage.filter((luggage) => luggage.luggagecount > 0).length > 0
                              ? item.luggage
                                .filter((luggage) => luggage.luggagecount > 0)
                                .map((luggage, index, array) => (
                                  <span key={luggage.luggagetype}>
                                    {luggage.luggagetype === "CHECK-IN SIZE"
                                      ? t("my_page.bookings_page.booking_item.check_in")
                                      : t("my_page.bookings_page.booking_item.cabin")}
                                    : {luggage.luggagecount}
                                    {index !== array.length - 1 ? ", " : ""}
                                  </span>
                                ))
                              : i18n.language === "en" ? <span className="tw:!text-[#8d8d8d] tw:!italic">None</span> : <span className="tw:!text-[#8d8d8d] tw:!italic">なし</span>}
                          </p>
                        </div>
                      </div>
                    </div>
                    {(index + 1) < cart.bookingInfo.length &&
                      <hr className="tw:!my-4 tw:!border-gray-100 tw:hidden! tw:md:block!" />
                    }
                  </div>
                )
              })}

              <hr className="tw:!my-4 tw:!border-gray-100 tw:hidden! tw:md:block!" />

              <div className="tw:hidden! tw:md:!flex tw:!justify-between tw:!items-start">
                <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
                  <div className="tw:!w-1/3">
                    <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.addOnService")}</p>
                    <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{getAddOnServices()}</p>
                  </div>
                  <div className="tw:!w-2/3">
                    <p className="tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1">{t("myPage.booking.bookingItem.title.additionalInformation")}</p>
                    <p className="tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0">{getAdditionalInformation()}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:hidden! tw:md:!flex tw:!bg-[#F9F9F9] tw:!px-4 tw:md:!px-8 tw:!py-4 tw:!border-t tw:!border-[#E8E8E8] tw:!justify-between tw:!items-center tw:!rounded-b-lg">
            <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[700] tw:!m-0">{t('myPage.booking.bookingItem.title.price')}</p>

            {/* Added flex layout to align all children to the right */}
            <div className="tw:!flex tw:!flex-col tw:!items-end">
              {
                priceBreakdown.hasDiscount && (
                  <p className="tw:!text-[13px] before-discount-price tw:!mb-0 tw:!text-right">{t("JPY")} {priceBreakdown.priceBeforeDiscount.toLocaleString()}{t("JPY.JP")}</p>
                )
              }
              <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] tw:!m-0 tw:!text-right">{`${priceBreakdown.totalPrice.toLocaleString()}${t('myPage.booking.bookingItem.JPY')}`}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewItemCardPaymentSuccess;